export default __webpack_public_path__ + "static/media/promos-icon-active.58a677f8.webp";